import { render } from "./imageZoomArrows.vue?vue&type=template&id=709deab9&scoped=true"
import script from "./imageZoomArrows.vue?vue&type=script&lang=ts"
export * from "./imageZoomArrows.vue?vue&type=script&lang=ts"

import "./imageZoomArrows.vue?vue&type=style&index=0&id=709deab9&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-709deab9"

export default script